<template>
	<section
		class="
			pt-6 pb-16 md:pt-12 relative min-h-[9.375rem]
			after:absolute after:inset-0 after:z-20 after:bg-black/[.4]
		"
	>
		<div class="container relative z-30 md:min-h-[14.5rem]">
			<Breadcrumbs
				class="
					max-w-max
					text-body-inverse
					px-4
					bg-background-darker/60 backdrop-blur-xs
					rounded-full
					mb-8
					md:mb-6
					overflow-hidden
				"
				hide-bg
			/>
			<h1
				v-if="!hideTitle && title"
				class="typo-display text-center mb-2 md:mb-4 text-heading-inverse"
				v-text="title"
			/>
			<div
				v-if="subtitle"
				class="rem:max-w-[840px] mx-auto md:mb-4 text-center font-normal typo-body-xl text-heading-inverse"
				v-text="subtitle"
			/>

			<slot name="aside" />
		</div>

		<slot name="image" />
	</section>
</template>

<script setup lang="ts">
	type Props = {
		title?: string;
		subtitle?: string;
		hideTitle?: boolean;
	};

	defineProps<Props>();
</script>
